import React from "react";

import { Navigate } from "react-router-dom";
import { Route } from "react-router-dom";

import { ERouteContext, ESharedRoutes,LevelSpecificRoute } from "routes/types";

import { getSharedRoutes } from "./sharedRoutesUtil";


const baseSharedRoutes = [
  ESharedRoutes.PRICING,
  ESharedRoutes.SETTINGS,
  ESharedRoutes.THEME,
  ESharedRoutes.PRODUCTS,
  ESharedRoutes.OFFERS_UI,
  ESharedRoutes.BADGES,
  ESharedRoutes.ASSETS,
  ESharedRoutes.BUNDLES,
  ESharedRoutes.PROMOTIONS,
  ESharedRoutes.POPUPS,
  ESharedRoutes.ROLLING,
  ESharedRoutes.CHECKOUT_LINKS,
  ESharedRoutes.PROFILE,
  ESharedRoutes.SUBSCRIPTIONS
];

export const createStoreRoutes = (
  basePath: string,
  defaultPage: string,
  context: ERouteContext,
  levelSpecificRoutes: LevelSpecificRoute[] = []
) => {
  const sharedRoutesList = baseSharedRoutes;

    if (context === ERouteContext.PROJECT) {
      sharedRoutesList.push(ESharedRoutes.PLAYERS, ESharedRoutes.LOCALIZATION, ESharedRoutes.ORDERS, ESharedRoutes.REPORTS);
    }

  return (
    <Route path={`${basePath}/*`}>
      <Route path="" element={<Navigate to={defaultPage} replace />} />
      {levelSpecificRoutes.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}
      {sharedRoutesList.map(route => (
        <React.Fragment key={route}>
          {getSharedRoutes(route, context)}
        </React.Fragment>
      ))}
    </Route>
  );
};
